var _style, _path, _path2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadersSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.1 100",
    width: 52,
    height: 52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#FA8503;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.1 80h-15V66.7c0-4.6-3.7-8.3-8.3-8.3h-10v-9.1l22.6-16.2c0.4-0.3 0.6-0.7 0.7-1.1 0.1-0.4 0-0.9-0.3-1.2l-5-6.7c-0.5-0.7-1.5-0.9-2.3-0.4L34.4 35.5c3-5.7 0.9-12.8-4.8-15.8 -5.7-3-12.8-0.9-15.8 4.8 -2.4 4.6-1.5 10.2 2.2 13.8h-1.8c-0.5 0-0.9 0.2-1.2 0.6L2.1 50.9c-3 3.3-2.8 8.3 0.3 11.5l8.8 8.9c0.3 0.3 0.8 0.5 1.3 0.5 0.5 0 0.9-0.3 1.2-0.7l2-2.8v30.2c0 0.9 0.7 1.7 1.7 1.7h10c0.9 0 1.7-0.7 1.7-1.7V71.7h11.7V80h-5c-0.9 0-1.7 0.7-1.7 1.7v16.7c0 0.9 0.7 1.7 1.7 1.7h33.3c0.9 0 1.7-0.7 1.7-1.7V81.7C70.8 80.7 70 80 69.1 80zM15.8 30c0-4.6 3.7-8.3 8.3-8.3s8.3 3.7 8.3 8.3 -3.7 8.3-8.3 8.3S15.8 34.6 15.8 30zM28.1 41.7l-2.3 4.6 -2.3-4.6H28.1zM15.8 59.5l-2.7-2.8L15.8 54V59.5zM27.5 68.3c-0.9 0-1.7 0.7-1.7 1.7v26.7h-6.7V50c0-0.7-0.4-1.3-1-1.5 -0.6-0.3-1.3-0.1-1.8 0.4l-6.7 6.7c-0.6 0.6-0.6 1.7 0 2.3l5.5 5.7 -2.8 3.9L4.8 60c-1.9-1.9-2-4.9-0.2-6.9l10.3-11.4h4.9l4.6 9.1c0.4 0.8 1.4 1.1 2.2 0.7 0.3-0.2 0.6-0.4 0.7-0.7l4.8-9.6 20-13.8 3 4 -21.9 15.7c-0.4 0.3-0.7 0.8-0.7 1.4V60c0 0.9 0.7 1.7 1.7 1.7h11.7c2.8 0 5 2.2 5 5V80h-6.7V70c0-0.9-0.7-1.7-1.7-1.7H27.5zM67.5 96.7h-30V83.3h30V96.7z",
    fill: "#156BA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 13.3c-6.4 0-11.7-5.2-11.7-11.7 0-0.9-0.7-1.7-1.7-1.7s-1.7 0.7-1.7 1.7c0 6.4-5.2 11.7-11.7 11.7 -0.9 0-1.7 0.7-1.7 1.7s0.7 1.7 1.7 1.7c6.4 0 11.7 5.2 11.7 11.7 0 0.9 0.7 1.7 1.7 1.7s1.7-0.7 1.7-1.7c0-6.4 5.2-11.7 11.7-11.7 0.9 0 1.7-0.7 1.7-1.7S98.4 13.3 97.5 13.3zM84.1 21.5c-1.4-2.8-3.7-5-6.5-6.5 2.8-1.4 5-3.7 6.5-6.5 1.4 2.8 3.7 5 6.5 6.5C87.8 16.4 85.6 18.7 84.1 21.5z",
    className: "a"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51.9,
    y: 43.3,
    transform: "matrix(0.8064 -0.5913 0.5913 0.8064 -16.0135 41.0712)",
    width: 5.6,
    height: 3.3,
    className: "a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.8,
    y: 32.8,
    transform: "matrix(0.8062 -0.5916 0.5916 0.8062 -6.9811 47.5738)",
    width: 20.7,
    height: 3.3,
    className: "a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 59.8,
    y: 21.7,
    transform: "matrix(0.832 -0.5547 0.5547 0.832 -1.892 40.4097)",
    width: 12,
    height: 3.3,
    className: "a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadersSupport);
export default __webpack_public_path__ + "static/media/leaders-support.2a84fb922db36ba5e21be2ff687f4a51.svg";
export { ForwardRef as ReactComponent };